(function () {
  function mountReveal() {
    var els = document.querySelectorAll('.wn .reveal, .wn-chrome .reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) {
        e.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    els.forEach(function (e) {
      io.observe(e);
    });
  }

  function mountCounters() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.wn [data-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-count'));
      var suffix = el.getAttribute('data-suffix') || '';
      if (reduce || isNaN(target)) {
        el.textContent = target + suffix;
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          var start = performance.now();
          var dur = 1400;
          var tick = function (now) {
            var k = Math.min(1, (now - start) / dur);
            var eased = 1 - Math.pow(1 - k, 3);
            el.textContent = Math.round(target * eased) + suffix;
            if (k < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        });
      });
      io.observe(el);
    });
  }

  function mountHeader() {
    var header = document.getElementById('wn-header');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var chrome = header.closest('.wn-chrome') || header.parentElement;
    var nav = document.getElementById('wn-nav');
    var toggle = document.getElementById('wn-nav-toggle');
    var backdrop = document.getElementById('wn-nav-backdrop');
    if (!nav || !toggle || !backdrop) return;

    var desktopMq = window.matchMedia('(min-width: 1001px)');
    var navHomeParent = nav.parentElement;
    var navHomeNext = nav.nextElementSibling;

    var placeNav = function () {
      if (desktopMq.matches) {
        if (navHomeParent && nav.parentElement !== navHomeParent) {
          if (navHomeNext && navHomeNext.parentElement === navHomeParent) {
            navHomeParent.insertBefore(nav, navHomeNext);
          } else {
            navHomeParent.appendChild(nav);
          }
        }
        if (backdrop.parentElement !== chrome) {
          chrome.appendChild(backdrop);
        }
      } else {
        /* Escape sticky/filter ancestors so position:fixed covers the viewport */
        if (nav.parentElement !== document.body) {
          document.body.appendChild(nav);
        }
        if (backdrop.parentElement !== document.body) {
          document.body.appendChild(backdrop);
        }
      }
    };

    var setOpen = function (open) {
      if (open && !desktopMq.matches) placeNav();
      nav.classList.toggle('is-open', open);
      backdrop.classList.toggle('is-open', open);
      backdrop.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('wn-nav-open', open);
      if (!open && desktopMq.matches) placeNav();
    };

    placeNav();
    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', function () {
        setOpen(false);
        placeNav();
      });
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(function () {
        setOpen(false);
        placeNav();
      });
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(!nav.classList.contains('is-open'));
    });
    backdrop.addEventListener('click', function () {
      setOpen(false);
    });
    nav.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (link && nav.contains(link)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  function mountAccordions() {
    document.querySelectorAll('.wn .acc__btn').forEach(function (btn) {
      if (btn.dataset.wnAccBound === '1') return;
      btn.dataset.wnAccBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.acc__item');
        if (!item) return;
        var panel = item.querySelector('.acc__panel');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        if (panel) {
          panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0';
        }
      });
    });
  }

  function formatMoney(cents, moneyFormat) {
    var format =
      moneyFormat ||
      (window.Shopify && window.Shopify.money_format) ||
      '${{amount}}';
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format);
      }
    } catch (err) {}
    var value = (Number(cents) / 100).toFixed(2);
    return String(format)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function mountProductDetail() {
    document.querySelectorAll('[data-wn-pdp]').forEach(function (root) {
      if (root.dataset.wnPdpBound === '1') return;
      root.dataset.wnPdpBound = '1';

      var media = root.querySelector('[data-wn-pdp-media]');
      var thumbs = root.querySelector('[data-wn-pdp-thumbs]');
      if (media && thumbs) {
        thumbs.addEventListener('click', function (e) {
          var btn = e.target.closest('button[data-media-src]');
          if (!btn) return;
          thumbs.querySelectorAll('button').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          var img = media.querySelector('img');
          if (img) {
            img.src = btn.getAttribute('data-media-src');
            img.srcset = btn.getAttribute('data-media-srcset') || '';
          }
        });
      }

      var form = root.querySelector('[data-wn-product-form]');
      var jsonEl = root.querySelector('[data-wn-product-json]');
      if (!form || !jsonEl) return;

      var product;
      try {
        product = JSON.parse(jsonEl.textContent);
      } catch (err) {
        return;
      }
      if (!product) return;

      // Expand compact womenion.variant_index (needed when Liquid's 250-variant
      // cap would otherwise drop colour×size combinations).
      if (product.variant_index && Array.isArray(product.variant_index.variants)) {
        var index = product.variant_index;
        var colours = index.colours || [];
        var sizes = index.sizes || [];
        var images = index.images || {};
        product.options = index.options || product.options;
        product.variants = index.variants.map(function (row) {
          var colour = colours[row[1]];
          var size = sizes[row[2]];
          var img = images[String(row[1])] || images[row[1]] || null;
          return {
            id: row[0],
            available: row[4] !== 0,
            options: [colour, size],
            price: row[3],
            compare_at_price: row.length > 5 ? row[5] : null,
            featured_image: img ? { src: img } : null,
          };
        });
      }

      if (!Array.isArray(product.variants) || !product.variants.length) return;

      var moneyFormat = root.getAttribute('data-money-format') || '';
      var variantInput = form.querySelector('[data-wn-variant-id]');
      var priceEl = root.querySelector('[data-wn-pdp-price]');
      var addBtn = form.querySelector('[data-wn-add]');
      var optionNodes = Array.prototype.slice.call(form.querySelectorAll('[data-wn-option]'));
      var optionNames = Array.isArray(product.options)
        ? product.options.map(function (option) {
            return typeof option === 'string' ? option : option && option.name;
          })
        : [];

      function readOptionValue(node) {
        if (!node) return null;
        var select = node.querySelector('select[data-wn-option-select]');
        if (select) return select.value;
        var active = node.querySelector('.is-active[data-option-value]');
        if (active) return active.getAttribute('data-option-value');
        var single = node.querySelector('.pdp__single-value[data-option-value]');
        if (single) return single.getAttribute('data-option-value');
        var first = node.querySelector('[data-option-value]');
        return first ? first.getAttribute('data-option-value') : null;
      }

      var selected = optionNames.map(function (_, i) {
        return readOptionValue(optionNodes[i]) || product.variants[0].options[i];
      });

      function variantMatches(variant, options) {
        return variant.options.every(function (opt, i) {
          return String(opt) === String(options[i]);
        });
      }

      function findExactVariant(options) {
        return product.variants.find(function (variant) {
          return variantMatches(variant, options);
        });
      }

      // An option value is buyable if any variant carries it and is available.
      // Do not require the current colour×size pair to already exist — incomplete
      // matrices are common under Shopify's variant limit; resolveSelection repairs.
      function optionValueAvailable(optionIndex, value) {
        return product.variants.some(function (variant) {
          return String(variant.options[optionIndex]) === String(value) && variant.available;
        });
      }

      function optionValuesForNode(node) {
        if (!node) return [];
        var select = node.querySelector('select[data-wn-option-select]');
        if (select) {
          return Array.prototype.map.call(select.options, function (opt) {
            return opt.value;
          });
        }
        return Array.prototype.map.call(node.querySelectorAll('[data-option-value]'), function (el) {
          return el.getAttribute('data-option-value');
        });
      }

      function firstAvailableValue(optionIndex, options) {
        var node = optionNodes[optionIndex];
        if (!node) return options[optionIndex];
        var values = optionValuesForNode(node);
        for (var i = 0; i < values.length; i += 1) {
          if (optionValueAvailable(optionIndex, values[i])) return values[i];
        }
        return options[optionIndex];
      }

      function resolveSelection(nextSelected, changedIndex) {
        var options = nextSelected.slice();
        if (findExactVariant(options)) return options;

        // Keep the changed option; repair other options to a real variant.
        if (typeof changedIndex === 'number') {
          var candidates = product.variants.filter(function (variant) {
            return String(variant.options[changedIndex]) === String(options[changedIndex]);
          });
          if (candidates.length) {
            var best = candidates[0];
            var bestScore = -1;
            candidates.forEach(function (variant) {
              var score = 0;
              variant.options.forEach(function (opt, i) {
                if (i !== changedIndex && String(opt) === String(options[i])) score += 1;
              });
              if (variant.available) score += 0.5;
              if (score > bestScore) {
                bestScore = score;
                best = variant;
              }
            });
            return best.options.slice();
          }
        }

        // Fallback: keep as many leading options as possible, then fill remaining.
        for (var index = options.length - 1; index >= 0; index -= 1) {
          if (findExactVariant(options)) break;
          options[index] = firstAvailableValue(index, options);
        }
        var fallback = findExactVariant(options) || product.variants.find(function (variant) {
          return variant.available;
        }) || product.variants[0];
        return fallback.options.slice();
      }

      function paintSelection() {
        optionNodes.forEach(function (node, optionIndex) {
          var current = selected[optionIndex];
          var select = node.querySelector('select[data-wn-option-select]');
          if (select) {
            if (String(select.value) !== String(current)) select.value = current;
            Array.prototype.forEach.call(select.options, function (opt) {
              // Keep every listed colour/size selectable; resolveSelection finds a
              // real variant. Do not disable or relabel options as sold out.
              opt.disabled = false;
              opt.classList.remove('is-unavailable');
            });
            return;
          }
          node.querySelectorAll('button[data-option-value]').forEach(function (btn) {
            var value = btn.getAttribute('data-option-value');
            var available = optionValueAvailable(optionIndex, value);
            btn.classList.toggle('is-active', String(value) === String(current));
            btn.classList.toggle('is-unavailable', !available);
            btn.setAttribute('aria-disabled', available ? 'false' : 'true');
          });
        });
      }

      function syncVariant() {
        var variant = findExactVariant(selected);
        if (!variant) {
          selected = resolveSelection(selected);
          variant = findExactVariant(selected);
        }
        if (!variant) return;

        paintSelection();

        if (variantInput) variantInput.value = variant.id;
        if (priceEl) {
          var html = formatMoney(variant.price, moneyFormat);
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html +=
              ' <span class="muted" style="text-decoration:line-through;font-size:1rem;margin-left:.4rem">' +
              formatMoney(variant.compare_at_price, moneyFormat) +
              '</span>';
          }
          priceEl.innerHTML = html;
        }
        if (addBtn) {
          var addLabel = addBtn.getAttribute('data-add-label') || addBtn.textContent.trim();
          var soldOutLabel = addBtn.getAttribute('data-sold-out-label') || addLabel;
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? addLabel : soldOutLabel;
        }
        // Prefer the selected variant image; if missing, reuse any same-colour
        // (or same first option) variant that has a featured image.
        var featured = variant.featured_image;
        if (!(featured && featured.src) && selected.length) {
          var colourValue = selected[0];
          var colourMatch = product.variants.find(function (candidate) {
            return (
              String(candidate.options[0]) === String(colourValue) &&
              candidate.featured_image &&
              candidate.featured_image.src
            );
          });
          if (colourMatch) featured = colourMatch.featured_image;
        }
        if (featured && featured.src && media) {
          var img = media.querySelector('img');
          if (img) {
            img.src = featured.src;
            img.removeAttribute('srcset');
            img.alt = product.title
              ? product.title + ' — ' + selected.filter(Boolean).join(' / ')
              : img.alt;
          }
          if (thumbs) {
            thumbs.querySelectorAll('button').forEach(function (thumb) {
              var thumbSrc = thumb.getAttribute('data-media-src') || '';
              var match =
                thumbSrc &&
                (featured.src.indexOf(thumbSrc.split('?')[0].split('/').pop()) !== -1 ||
                  thumbSrc.indexOf(featured.src.split('?')[0].split('/').pop()) !== -1);
              thumb.classList.toggle('is-active', Boolean(match));
            });
          }
        }

        if (variant.id && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', String(variant.id));
            window.history.replaceState({}, '', url.toString());
          } catch (err) {}
        }
      }

      optionNodes.forEach(function (node, optionIndex) {
        var select = node.querySelector('select[data-wn-option-select]');
        if (select) {
          select.addEventListener('change', function () {
            var next = selected.slice();
            next[optionIndex] = select.value;
            selected = resolveSelection(next, optionIndex);
            syncVariant();
          });
          return;
        }

        node.addEventListener('click', function (e) {
          var btn = e.target.closest('button[data-option-value]');
          if (!btn || !node.contains(btn)) return;
          if (btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-unavailable')) {
            // Allow choosing an unavailable value only if some variant exists for it;
            // resolveSelection will switch sibling options to a valid combination.
            var value = btn.getAttribute('data-option-value');
            var existsAnywhere = product.variants.some(function (variant) {
              return String(variant.options[optionIndex]) === String(value);
            });
            if (!existsAnywhere) return;
          }

          var next = selected.slice();
          next[optionIndex] = btn.getAttribute('data-option-value');
          selected = resolveSelection(next, optionIndex);
          syncVariant();
        });
      });

      selected = resolveSelection(selected);
      syncVariant();
    });
  }

  function mountShopCarousel() {
    document.querySelectorAll('[data-wn-carousel]').forEach(function (root) {
      if (root.dataset.wnCarouselBound === '1') return;
      root.dataset.wnCarouselBound = '1';
      var track = root.querySelector('[data-carousel-track]');
      if (!track) return;
      function step() {
        var slide = track.querySelector('.wn-shop-carousel__slide');
        if (!slide) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  function boot() {
    mountHeader();
    mountReveal();
    mountCounters();
    mountAccordions();
    mountProductDetail();
    mountShopCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
